import { AxiosInstance } from 'axios';
import {
	VstsAccount,
	VstsIdentityField,
	VstsProcessWorkItemType,
	VstsProject,
	VstsTeam,
	VstsTeamBoard,
	VstsTeamBoardDetails,
	VstsTeamMember,
	VstsWorkItemType,
} from './VstsSourceSettings.types';

export class VstsSourceSettingsApi {
	constructor(private client: AxiosInstance) {}

	async getAccounts(boardId: string, connectionId: string): Promise<VstsAccount[]> {
		const response = await this.client.get<VstsAccount[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts`,
		);

		return response.data;
	}

	async getProjects(
		boardId: string,
		connectionId: string,
		accountName: string,
	): Promise<VstsProject[]> {
		const response = await this.client.get<VstsProject[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/projects`,
		);

		return response.data;
	}

	async getWorkItemTypes(
		boardId: string,
		connectionId: string,
		accountName: string,
		projectId: string,
	): Promise<VstsWorkItemType[]> {
		const response = await this.client.get<VstsWorkItemType[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/projects/${encodeURIComponent(projectId)}/workitemtypes`,
		);

		return response.data;
	}

	async getTeams(
		boardId: string,
		connectionId: string,
		accountName: string,
		projectId: string,
	): Promise<VstsTeam[]> {
		const response = await this.client.get<VstsTeam[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/projects/${encodeURIComponent(projectId)}/teams`,
		);

		return response.data;
	}

	async getTeamBoards(
		boardId: string,
		connectionId: string,
		accountName: string,
		projectId: string,
		teamId: string,
	): Promise<VstsTeamBoard[]> {
		const response = await this.client.get<VstsTeamBoard[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/projects/${encodeURIComponent(projectId)}/teams/${encodeURIComponent(teamId)}/boards`,
		);

		return response.data;
	}

	async getTeamBoardDetails(
		boardId: string,
		connectionId: string,
		accountName: string,
		projectId: string,
		teamId: string,
		teamBoardId: string,
	): Promise<VstsTeamBoardDetails> {
		const response = await this.client.get<VstsTeamBoardDetails>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/projects/${encodeURIComponent(projectId)}/teams/${encodeURIComponent(teamId)}/boards/${encodeURIComponent(teamBoardId)}`,
		);

		return response.data;
	}

	async getTeamMembers(
		boardId: string,
		connectionId: string,
		accountName: string,
		projectId: string,
		teamId: string,
	): Promise<VstsTeamMember[]> {
		const response = await this.client.get<VstsTeamMember[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/projects/${encodeURIComponent(projectId)}/teams/${encodeURIComponent(teamId)}/members`,
		);

		return response.data;
	}

	async getProcessWorkItemTypes(
		boardId: string,
		connectionId: string,
		accountName: string,
		projectIds: string[],
	): Promise<VstsProcessWorkItemType[]> {
		const response = await this.client.post<VstsProcessWorkItemType[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/processWorkItemTypes`,
			projectIds,
		);

		return response.data;
	}

	async getIdentityFields(
		boardId: string,
		connectionId: string,
		accountName: string,
	): Promise<VstsIdentityField[]> {
		const response = await this.client.get<VstsIdentityField[]>(
			`/api/boards/${encodeURIComponent(boardId)}/connections/${encodeURIComponent(connectionId)}/vsts/accounts/${encodeURIComponent(accountName)}/identityFields`,
		);

		return response.data;
	}
}
